
import React, { useContext, useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";

import { clearOrder, listCategories, listProducts } from "../actions";
import { DialogPopup } from "../components/DialogPopup.jsx";
import OrderDetailsFooter from "../components/OrderDetailsFooter.jsx";
import { Store } from "../store.jsx";
import { useStyles } from "../styles";
import CategorySidebar from "../components/Order/CategorySidebar.jsx";
import ProductGrid from "../components/Order/ProductGrid.jsx";
import CategoryHeader from "../components/Order/CategoryHeader.jsx";
import { formatPrice } from "../utils/priceUtils.js";

import { getRestauranteFromStorage, ensureRestauranteLoaded, getRestauranteIdSync } from '../services/selectedRestaurante';

const OrderScreen = (props) => {
    const [restaurante, setRestaurante] = useState({});
    const styles = useStyles(restaurante);
    const [categoryName, setCategoryName] = useState('');
    const [categoryId, setCategoryId] = useState(0);
    const [product, setProduct] = useState({});
    const [isOpen, setIsOpen] = useState(false);

    const categoryClickHandler = (category) => {
        setCategoryName(category.nome);
        setCategoryId(category.id);
        listProducts(dispatch, category.id);
    };

    const productClickHandler = (p) => {
        setProduct(p);
        setIsOpen(true);
    };

    const cancelOrderHandler = () => {
        clearOrder(dispatch);
        props.history.push('/')
    }

    const previewOrderHandler = () => {
        props.history.push('/review');
    };

    const { state, dispatch } = useContext(Store);
    const { categories, loading, error } = state.categoryList;
    const { products, loading: loadingProducts, error: errorProducts } = state.productList;
    const { orderItems } = state.order;

    // Reload categories whenever the selected restaurant changes or on mount
    const [selectedRestauranteId, setSelectedRestauranteId] = useState(getRestauranteIdSync());

    useEffect(() => {
        setSelectedRestauranteId(getRestauranteIdSync());
        // Always (re)load categories for the current restaurant
        listCategories(dispatch);
        // Reset selected category so user picks for this restaurant
        setCategoryName('');
        setCategoryId(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    // When categories exist and a category is active, (re)load products unless the modal is open
    useEffect(() => {
        if (categories && !isOpen) {
            listProducts(dispatch, categoryId);
        }
    }, [dispatch, categories, categoryId, isOpen]);

    useEffect(() => {
        const loadRestaurante = async () => {
            let rest = getRestauranteFromStorage();

            if (!rest) {
                rest = await ensureRestauranteLoaded();
            }

            setRestaurante(rest || {});

        };

        loadRestaurante();
    }, []);


    return (
        <Box style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'hidden'
        }}>
            <DialogPopup
                product={product}
                orderItems={orderItems}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                dispatch={dispatch}
            />

            {/* Container principal com sidebar e conteúdo */}
            <Box style={{
                flex: 1,
                display: 'flex',
                overflow: 'hidden',
                paddingBottom: '200px' // Espaço para o footer
            }}>
                {/* Sidebar fixa */}
                <CategorySidebar
                    loading={loading}
                    error={error}
                    categories={categories || []}
                    categoryClickHandler={categoryClickHandler}
                />

                {/* Área principal com margem para a sidebar */}
                <Box style={{
                    marginLeft: '16.666%', // equivalente a md={2}
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                }}>
                    <CategoryHeader categoryName={categoryName} />
                    <Box
                        className="product-scroll-container"
                        style={{
                            flex: 1,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                            touchAction: 'pan-y',
                            paddingBottom: '220px' // Espaço extra para o footer
                        }}
                    >
                        <ProductGrid
                            loadingProducts={loadingProducts}
                            errorProducts={errorProducts}
                            products={products || []}
                            handlePrice={formatPrice}
                            productClickHandler={productClickHandler}
                        />
                    </Box>
                </Box>
            </Box>

            {/* Footer sempre visível no bottom */}
            <Box style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000
            }}>
                <OrderDetailsFooter
                    btnLeft="Cancelar"
                    btnLeftHandler={cancelOrderHandler}
                    btnLeftVariant="outlined"
                    btnRight="Prosseguir"
                    btnRightHandler={previewOrderHandler}
                    btnRightVariant="contained"
                />
            </Box>
        </Box>
    );
}

export default OrderScreen;
